import { colors, headingFont } from 'styles/colors';
import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Brand = styled.a`
  font-family: ${headingFont};
  font-size: 1.75rem;
  font-weight: 600;
  color: ${colors.ink};
`;
